
<template>
  <div>
    <!--eslint-disable vue/no-use-v-if-with-v-for -->
    <div
      id="khi_filter"
      class="uk-container"
    >
      <kursfilter />
    </div>
    <div v-if="firstRun">
      <div
        id="khi_liste"
        class="uk-container "
      >
        KHI Topkurse
        <div
          class="uk-grid"
        >
          <kurslistitem
            v-for="kurs in topkurse"
            :key="kurs.interneid"
            :kurs="kurs"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="kursliste.length > 0"
        class="uk-container"
      >
        <div
          v-if="gruppeUID != 0 || artUID != 0"
          class="iCountUp uk-width-1-1"
        >
          <ICountUp
            :end-val="kursliste.length"
            :options="options"
          />
          Treffer
        </div>
        <div
          id="khi_liste"
          class="uk-container "
        >
          <div class="uk-grid">
            <kurslistitem
              v-for="kurs in kursliste"
              :key="kurs.interneid"
              :kurs="kurs"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div
          v-if="gruppeUID != 0 || artUID != 0"
          class="keine-ergebnisse uk-container uk-text-center uk-animation-shake"
        >
          <h3>
            Keine Ergebnisse gefunden, bitte verändern Sie Ihre Sucheingaben
          </h3>
        </div>
      </div>
      <div
        id="khi_liste"
        class="uk-container "
      >
        KHI Topkurse
        <div
          class="uk-grid"
        >
          <kurslistitem
            v-for="kurs in topkurse"
            :key="kurs.interneid"
            :kurs="kurs"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ICountUp from 'vue-countup-v2';
import kursfilter from './filter.vue';
import kurslistitem from './kurslistitem.vue';

export default {
  name: 'Khi',
  components: {
    kursfilter,
    kurslistitem,
    ICountUp,
  },
  data() {
    return {
      options: {
        useEasing: true,
        useGrouping: false,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: '',
      },
      gruppeUID: null,
      artUID: null,
    };
  },
  mounted() {
    // stoße Store Ajax an....
    // this.$store.dispatch('loadKurse', false);
    console.log('KHI.vue mounted', this.$route, this.$router);
    this.kursnummer = this.$route.params.kursnummer;
    console.log(`kursnummer: ${this.kursnummer}`);

    if (window.location.href.indexOf('/kurs/') === -1) {
      console.log('khi.vue mounted, fetching url params:', this.$route.params);
      console.log(`gruppeUID: ${this.$route.params.gruppeUID}`);
      console.log(`artUID: ${this.$route.params.artUID}`);
      if (this.$route.params.gruppeUID) {
        this.gruppeUID = this.$route.params.gruppeUID;
        this.setFilter({
          type: 'gruppe',
          val: Number(this.gruppeUID),
        });
      }
      if (this.$route.params.artUID) {
        this.artUID = this.$route.params.artUID;
        this.setFilter({
          type: 'art',
          val: Number(this.artUID),
        });
      }
    } else {
      // deep link kurs-item hier
      console.log('deep link kurs-item hier');
      // :to="{name: 'Kurs', params: {kursnummer: kurs.interneid}}"

      this.$router.push({
        name: 'Kurs',
        params: {
          kursnummer: this.$route.params.artUID,
        },
      });
    }

    console.log(`kursliste.length: ${this.kursliste.length}`);
  },
  updated() {
    // console.log('KHI.vue updated', this.$route, this.$router);
  },
  computed: {
    ...mapGetters(['kursliste', 'kurse', 'firstRun']),
    topkurse() {
      const topkursArr = _.filter(this.kurse, k => k.topkurs === 1);
      console.log('topkursArr', topkursArr);

      if (topkursArr.length > 4) {
        topkursArr.length = 4;
      }
      return topkursArr;
    },
    isTopkurs() {
      if (this.kurs) {
        return this.kurs.topkurs === 1;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations(['setFilter']),
  },
};
</script>

<style scoped>
</style>
